import React, { useEffect, useState } from 'react';
import '../css/LoginPage.css';
import SignUpNavbar from './SignUpNavbar';
import ProfileNavBar from './ProfileNavBar';
import UserFooter from './UserFooter';
import Footer from './Footer';
import { Link } from 'react-router-dom';
import ChatComponent from './ChatComponent';

const ProfilePage = () => {
    const user = JSON.parse(sessionStorage.getItem('user'));
    const [userDetails, setUserDetails] = useState({});
    const [usersPlan, setUsersPlan] = useState({});

    if (!user) {
        window.location.href = '/';
    }

    const fetchRequests = async () => {
        fetch('https://18.117.231.157/api/getuserdetails', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ userID: user.userID })
        })
            .then((res) => res.json())
            .then((data) => {
                if (data.success) {
                    setUserDetails(data.userDetails);
                }
            })
            .catch((err) => console.error('Error fetching user details:', err));

        fetch('https://18.117.231.157/api/getuseractiveplan', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ userID: user.userID })
        })
            .then((res) => res.json())
            .then((data) => {
                if (data.success) {
                    setUsersPlan(data.plan);
                }
            })
            .catch((err) => console.error('Error fetching user plan:', err));
        };
        
    useEffect(() => {
        fetchRequests();
    }, []);

    const handleUpdate = (e) => {
        e.preventDefault();

        fetch('https://18.117.231.157/api/updateProfile', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                userID: user.userID,
                firstName: userDetails.firstName,
                lastName: userDetails.lastName
            })
        })
            .then((res) => res.json())
            .then((data) => {
                if (data.success) {
                    alert("Profile updated successfully!");
                } else {
                    alert("Update failed.");
                }
            })
            .catch((err) => {
                console.error("Error updating profile:", err);
                alert("Server error.");
            });
    };

    return (
        <div>
            <ProfileNavBar />
            <br /><br /><br /><br /><br />
            <h1 className='contactuspageheaders'>Profile</h1>
            <br />
            <form className='loginform' onSubmit={handleUpdate}>
                {/* First Name - Editable */}
                <label htmlFor="firstName">First Name</label>
                <input
                    type="text"
                    id="firstName"
                    name="firstName"
                    value={userDetails.firstName || ''}
                    onChange={(e) => setUserDetails({ ...userDetails, firstName: e.target.value })}
                    required
                />

                {/* Last Name - Editable */}
                <label htmlFor="lastName">Last Name</label>
                <input
                    type="text"
                    id="lastName"
                    name="lastName"
                    value={userDetails.lastName || ''}
                    onChange={(e) => setUserDetails({ ...userDetails, lastName: e.target.value })}
                    required
                />

                {/* Email - Readonly */}
                <label htmlFor="email">Email</label>
                <input
                    style={{ backgroundColor: 'gray' }}
                    type="email"
                    id="email"
                    name="email"
                    value={userDetails.email || ''}
                    readOnly
                />
                <div>
                <Link to='/forgotpassword' className='loginbutton'>
                                Reset Password
                            </Link>
                </div>
                <br></br>

                


                {usersPlan && usersPlan.planName && (
                    <>
                        <label htmlFor="planName">Active Plan</label>
                        <div style={{ display: 'flex', flexDirection: 'row' }}>
                            <input
                                
                                style={{ flex: 4, backgroundColor: 'gray' }}
                                type="text"
                                id="planName"
                                name="planName"
                                value={usersPlan.planName}
                                readOnly
                            />
                            <Link to='/bmicalculator' style={{ flex: 1, margin: '1%', textAlign: 'center' }} className='loginbutton'>
                                Change Plan
                            </Link>
                            <button
                                className='loginbutton'
                                style={{ flex: 1, margin: '1%', textAlign: 'center' }}
                                onClick={async () => {
                                    const confirmRemove = window.confirm("Are you sure you want to remove your current plan?");
                                    if (!confirmRemove) return;

                                    try {
                                        const res = await fetch('https://18.117.231.157/api/removeuseractiveplan', {
                                            method: 'POST',
                                            headers: {
                                                'Content-Type': 'application/json'
                                            },
                                            body: JSON.stringify({ userID: user.userID })
                                        });

                                        const data = await res.json();
                                        if (data.success) {
                                            alert("Plan removed successfully!");
                                            window.location.reload(); // Reload to refresh the plan display
                                        } else {
                                            alert("Failed to remove plan.");
                                        }
                                    } catch (error) {
                                        console.error('Error removing plan:', error);
                                        alert("Server error.");
                                    }
                                }}
                            >
                                Remove Plan
                            </button>

                        </div>

                        <label htmlFor="planDuration">Plan Duration</label>
                        <input
                        style={{ backgroundColor: 'gray' }}
                            type="text"
                            id="planDuration"
                            name="planDuration"
                            value={`${usersPlan.planDuration} Months`}
                            readOnly
                        />

                        <div className='rowtype'>
                            <div className='columntype' style={{ width: '100%' }}>
                                <label htmlFor="startDate">Plan Start Date</label>
                                <input
                                style={{ backgroundColor: 'gray' }}
                                    type="text"
                                    id="startDate"
                                    name="startDate"
                                    value={usersPlan.startDate ? new Date(usersPlan.startDate).toLocaleDateString('en-US') : ''}
                                    readOnly
                                />
                            </div>

                            <div className='columntype' style={{ width: '100%' }}>
                                <label htmlFor="endDate">Plan End Date</label>
                                <input
                                style={{ backgroundColor: 'gray' }}
                                    type="text"
                                    id="endDate"
                                    name="endDate"
                                    value={usersPlan.endDate ? new Date(usersPlan.endDate).toLocaleDateString('en-US') : ''}
                                    readOnly
                                />
                            </div>
                        </div>
                    </>
                )}

                <br></br>
                <button className='loginbutton' type='submit'>Update Profile</button>
            </form>

            <br /><br /><br /><br />
            <ChatComponent />
            <UserFooter />
            <Footer />
        </div>
    );
};

export default ProfilePage;
